/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import SalesTable from "examples/Tables/SalesTable";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import GradientLineChart from "examples/Charts/LineCharts/GradientLineChart";
import Globe from "examples/Globe";

// Soft UI Dashboard PRO React base styles
import typography from "assets/theme/base/typography";
import breakpoints from "assets/theme/base/breakpoints";

// Data
import salesTableData from "layouts/dashboards/default/data/salesTableData";
import reportsBarChartData from "layouts/dashboards/default/data/reportsBarChartData";
import gradientLineChartData from "layouts/dashboards/default/data/gradientLineChartData";
import PageLayout from "examples/LayoutContainers/PageLayout";
import Loader from "examples/Loader";
import { useState } from "react";

function Default() {
  const { values } = breakpoints;
  const { size } = typography;
  const { chart, items } = reportsBarChartData;
  const [loader, setLoader] = useState(false);

  return (
    loader ?
      <Loader />
      :
      <PageLayout>
        {/* <DashboardNavbar /> */}
        <SoftBox py={3}>
          <Grid container>
            <Grid item xs={12} lg={12}>
              <SoftBox mb={3} p={1}>
                <SoftTypography
                  variant={window.innerWidth < values.sm ? "h3" : "h2"}
                  textTransform="capitalize"
                  fontWeight="bold"
                >
                  general statistics
                </SoftTypography>
              </SoftBox>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={3}>
                  <SoftBox mb={3}>
                    <MiniStatisticsCard
                      title={{ text: "today's money", fontWeight: "bold" }}
                      count="$53,000"
                      percentage={{ color: "success", text: "+55%" }}
                      icon={{ color: "info", component: "paid" }}
                    />
                  </SoftBox>
                  <MiniStatisticsCard
                    title={{ text: "today's users", fontWeight: "bold" }}
                    count="2,300"
                    percentage={{ color: "success", text: "+3%" }}
                    icon={{ color: "info", component: "public" }}
                  />
                </Grid> 
                <Grid item xs={12} sm={3}>
                  <SoftBox mb={3}>
                    <MiniStatisticsCard
                      title={{ text: "new clients", fontWeight: "bold" }}
                      count="+3,462"
                      percentage={{ color: "error", text: "-2%" }}
                      icon={{ color: "info", component: "emoji_events" }}
                    />
                  </SoftBox>
                  <SoftBox mb={3}>
                    <MiniStatisticsCard
                      title={{ text: "sales", fontWeight: "bold" }}
                      count="$103,430"
                      percentage={{ color: "success", text: "+5%" }}
                      icon={{
                        color: "info",
                        component: "shopping_cart",
                      }}
                    />
                  </SoftBox>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <SoftBox mb={3}>
                    <MiniStatisticsCard
                      title={{ text: "today's money", fontWeight: "bold" }}
                      count="$53,000"
                      percentage={{ color: "success", text: "+55%" }}
                      icon={{ color: "info", component: "paid" }}
                    />
                  </SoftBox>
                  <MiniStatisticsCard
                    title={{ text: "today's users", fontWeight: "bold" }}
                    count="2,300"
                    percentage={{ color: "success", text: "+3%" }}
                    icon={{ color: "info", component: "public" }}
                  />
                </Grid> 
                <Grid item xs={12} sm={3}>
                  <SoftBox mb={3}>
                    <MiniStatisticsCard
                      title={{ text: "new clients", fontWeight: "bold" }}
                      count="+3,462"
                      percentage={{ color: "error", text: "-2%" }}
                      icon={{ color: "info", component: "emoji_events" }}
                    />
                  </SoftBox>
                  <SoftBox mb={3}>
                    <MiniStatisticsCard
                      title={{ text: "sales", fontWeight: "bold" }}
                      count="$103,430"
                      percentage={{ color: "success", text: "+5%" }}
                      icon={{
                        color: "info",
                        component: "shopping_cart",
                      }}
                    />
                  </SoftBox>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <GradientLineChart
                  title="Sales Overview"
                  description={
                    <SoftBox display="flex" alignItems="center">
                      <SoftBox fontSize={size.lg} color="dark" mb={0.3} mr={0.5} lineHeight={0}>
                        <Icon sx={{ fontWeight: "bold" }}>arrow_upward</Icon>
                      </SoftBox>
                      <SoftTypography variant="button" color="text" fontWeight="medium">
                        4% more{" "}
                        <SoftTypography variant="button" color="text" fontWeight="regular">
                          in 2021
                        </SoftTypography>
                      </SoftTypography>
                    </SoftBox>
                  }
                  chart={gradientLineChartData}
                />
              </Grid>
            </Grid>
          </Grid>
        </SoftBox>
      </PageLayout>
  );
}

export default Default;
